import { Routes } from "@angular/router";
import { CounterComponent } from "./counter/counter.component";
import { FetchDataComponent } from "./fetch-data/fetch-data.component";
import { PermissionGuard } from "./guards/permission.guard";
import { RevenueManagementListComponent } from "./revenueManagementList/revenue-management-list.component";
import { OfflineTicketIssueComponent } from "./offlineTicketIssue/offline-ticket-issue.component";
import { PricingandstructureComponent } from "./pricingandstructure/pricingandstructure.component";
import { FlightSearchNew1Component } from "./flight-search-new1/flight-search-new1.component";
import { RevenueManagementComponent } from "./revenueManagement/revenue-management.component";
import { FlightResultsNewComponent } from "./flightResultsNew/flight-results-new.component";
import { OfflineRequestComponent } from "./offlineRequestList/offline-request.component";
import { OfflineRequestAddEditComponent } from "./offlineRequestAddEdit/offline-request-add-edit.component";
import { ManagerOnlineRequestListComponent } from "./managerOnlineRequestList/manager-online-request-list.component";
import { ManagerOfflineRequestListComponent } from "./managerOfflineRequestList/manager-offline-request-list.component";
import { PassengerInfoComponent } from "./passengerInfo/passengerInfo.component";
import { BookingListComponent } from "./bookingList/bookingList.component";
import { TicketIssuanceComponent } from "./ticket-issuance/ticket-issuance.component";
import { AirportManageComponent } from "./airport-manage/airport-manage.component";
import { OfflineMyBookingTktListComponent } from "./offline-my-booking-tkt-list/offline-my-booking-tkt-list.component";
import { RefundTicketOnlineComponent } from "./refund-ticket-online/refund-ticket-online.component";
import { AirlinesMasterComponent } from "./airlines-master/airlines-master.component";
import { BookingListSearchCriteriaComponent } from "./booking-list-search-criteria/booking-list-search-criteria.component";
import { ImportPnrComponent } from "./import-pnr/import-pnr.component";
import { ImportPnrListComponent } from "./import-pnr-list/import-pnr-list.component";
import { VoidRevenueManagementComponent } from "./void-revenue-management/void-revenue-management.component";
import { RefundRevenueComponent } from "./refund-revenue/refund-revenue.component";
import { ImportRevenueManagementComponent } from "./ImportPNRrevenueManagement/importrevenue-management.component";
import { PostAncillaryComponent } from "./post-Ancillary/post-ancillary.component";
import { GroupTicketComponent } from "./groupTicket/groupTicket.component";
import { FlyDubaiModifyComponent } from "./flyDubaiModification/flydubai-modify.component";
import { AirblueModifyComponent } from "./airblue-Modify/airblue-modify.component";
import { SpiceModificationComponent } from "./SpiceModification/spice-modification.component";
import { ModifyAirItineraryComponent } from "./modify-air-itinerary/modify-air-itinerary.component";
import { OfflineBookingCreateComponent } from "./offlineBookingRequest/offlineBookingRequest.component";
import { EmiratesModificationComponent } from "./emirates-modification/emirates-modification.component";
import { ImportPnrEntryComponent } from "./import-pnr-entry/import-pnr-entry.component";
import { GroupRevenueReportComponent } from "./group-revenue-report/group-revenue-report.component";
import { RevenueReportComponent } from "./revenueReport/revenueReport.component";
import { GroupTicketForUserNewComponent } from "./group-ticket-for-user-new/group-ticket-for-user-new.component";
import { AddGroupTitleComponent } from "./add-group-title/add-group-title.component";
import { TravelInsuranceComponent } from "./travel-insurance/travel-insurance.component";
import { UnitedInsuranceHomeComponent } from "./united-insurance-home/united-insurance-home.component";
import { TravelInsuranceIssuanceComponent } from "./travel-insurance-issuance/travel-insurance-issuance.component";
import { TravelInsurancePlanResultsComponent } from "./travel-insurance-plan-results/travel-insurance-plan-results.component";
import { TravelInsurancePassengersComponent } from "./travel-insurance-passengers/travel-insurance-passengers.component";
import { TravelInsuranceBookingComponent } from "./travel-insurance-booking/travel-insurance-booking.component";
import { TravelInsuranceCancellationComponent } from "./travel-insurance-cancellation/travel-insurance-cancellation.component";
import { TravelInsuranceRevenueManagementComponent } from "./travelInsurance-Revenue-Management/travelInsurance-Revenue-Management.component";
import { UnitedInsuranceComponent } from "./united-insurance/united-insurance.component";
import { ManagerProficiencyReportComponent } from "./manager-proficiency-report/manager-proficiency-report.component";
import { TravelPortModificationComponent } from "./travel-port-modification/travel-port-modification.component";
import { MasterPassengerInfoComponent } from "./master-passenger-info/master-passenger-info.component";
import { MasterPassengerInfoListComponent } from "./master-passenger-info-list/master-passenger-info-list.component";
import { OfflineSupplierListComponent } from "./offline-supplier-list/offline-supplier-list.component";
import { OfflineSupplierComponent } from "./offline-supplier/offline-supplier.component";
import { ChatComponent } from "./chat/chat.component";
import { OfflineBackOfficeReportComponent } from "./offline-back-office-report/offline-back-office-report.component";
import { OfflineTicketComponent } from "./offline-new/offline-ticket/offline-ticket.component";
import { OfflineBookingComponent } from "./offline-new/offline-booking/offline-booking.component";
import { OfflineReissueComponent } from "./offline-new/offline-reissue/offline-reissue.component";
import { OfflineRefundComponent } from "./offline-new/offline-refund/offline-refund.component";
import { OfflineVoidComponent } from "./offline-new/offline-void/offline-void.component";
import { OfflineFlightSearchComponent } from "./offline-new/offline-flight-search/offline-flight-search.component";
import { ZeusBookedPoliciesComponent } from "./zeus-booked-policies/zeus-booked-policies.component";
import { BackOfficeInsuranceReportComponent } from "./back-office-insurance-report/back-office-insurance-report.component";
import { ImportPnrForOfflineIssuedComponent } from "./import-pnr-for-offline-issued/import-pnr-for-offline-issued.component";
import { DataFetchedFromOfflineComponent } from "./data-fetched-from-offline/data-fetched-from-offline.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";

export const routes: Routes = [
  {
    path: "",
    loadComponent: () =>
      import("./home-new/home-new.component").then((m) => m.HomeNewComponent),
    pathMatch: "full",
  },
  {
    path: "home",
    loadComponent: () =>
      import("./home-new/home-new.component").then((m) => m.HomeNewComponent),
  },
  {
    path: "sliderImages",
    loadComponent: () =>
      import("./cms-login-slider-images/cms-login-slider-images.component").then(
        (m) => m.CmsLoginSliderImagesComponent,
      ),
  },
  { path: "counter", component: CounterComponent },
  { path: "fetch-data", component: FetchDataComponent },
  {
    path: "users",
    loadComponent: () =>
      import("./users/users.component").then((m) => m.UsersComponent),
    canActivate: [PermissionGuard],
    data: { permissions: ["users"] },
  },
  {
    path: "branchInformation",
    loadComponent: () =>
      import("./branchInformation/branch-information.component").then(
        (m) => m.BranchInformationComponent,
      ),
  },
  {
    path: "agencyMaster",
    loadComponent: () =>
      import("./agencyMaster/agency-master.component").then(
        (m) => m.AgencyMasterComponent,
      ),
  },
  {
    path: "agencyList",
    loadComponent: () =>
      import("./agencyList/agency-list.component").then(
        (m) => m.AgencyListComponent,
      ),
  },
  {
    path: "branchList",
    loadComponent: () =>
      import("./branchList/branch-list.component").then(
        (m) => m.BranchListComponent,
      ),
  },
  {
    path: "agencyRights",
    loadComponent: () =>
      import("./agencyRights/agency-rights.component").then(
        (m) => m.AgencyRightsComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["accountManagement"] },
  },
  {
    path: "userList",
    loadComponent: () =>
      import("./userList/user-list.component").then((m) => m.UserListComponent),
    canActivate: [PermissionGuard],
    data: { permissions: ["users"] },
  },
  {
    path: "agencyBranchChart",
    loadComponent: () =>
      import("./agencyBranchChart/agency-branch-chart.component").then(
        (m) => m.AgencyBranchChartComponent,
      ),
  },
  //{ path: 'home', component: HomeComponent },
  {
    path: "suppliersList",
    loadComponent: () =>
      import("./suppliersList/suppliers-list.component").then(
        (m) => m.SuppliersListComponent,
      ),
  },
  {
    path: "suppliersAddEdit",
    loadComponent: () =>
      import("./suppliersAddEdit/suppliers-add-edit.component").then(
        (m) => m.SuppliersAddEditComponent,
      ),
  },
  {
    path: "cms",
    loadComponent: () =>
      import("./cms/cms.component").then((m) => m.CMSComponent),
    canActivate: [PermissionGuard],
    data: { permissions: ["cms"] },
  },
  {
    path: "currency-conversion",
    loadComponent: () =>
      import("./currency-conversion/currency-conversion.component").then(
        (m) => m.CurrencyConversionComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["currency"] },
  },
  {
    path: "cms-add-header",
    loadComponent: () =>
      import("./cms-sub-header/cms-sub-header.component").then(
        (m) => m.CmsSubHeaderComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["cms"] },
  },
  {
    path: "cms-add-landing",
    loadComponent: () =>
      import("./cms-sub-landing/cms-sub-landing.component").then(
        (m) => m.CmsSubLandingComponent,
      ),
  },
  {
    path: "cms-add-deals",
    loadComponent: () =>
      import("./cms-sub-deals/cms-sub-deals.component").then(
        (m) => m.CmsSubDealsComponent,
      ),
  },
  {
    path: "cms-add-footer-sitemap",
    loadComponent: () =>
      import("./cms-sub-fsitemap/cms-sub-fsitemap.component").then(
        (m) => m.CmsSubFSitemapComponent,
      ),
  },
  {
    path: "cms-add-footer-social",
    loadComponent: () =>
      import("./cms-sub-fsocial/cms-sub-fsocial.component").then(
        (m) => m.CmsSubFSocialComponent,
      ),
  },
  {
    path: "cms-add-footer-contacts",
    loadComponent: () =>
      import("./cms-sub-fcontacts/cms-sub-fcontacts.component").then(
        (m) => m.CmsSubFContactsComponent,
      ),
  },
  {
    path: "app-contactus",
    loadComponent: () =>
      import("./contactus/contactus.component").then(
        (m) => m.ContactUsComponent,
      ),
  },
  {
    path: "app-aboutus",
    loadComponent: () =>
      import("./aboutus/aboutus.component").then((m) => m.AboutUsComponent),
  },
  {
    path: "app-cms-sub-contactus",
    loadComponent: () =>
      import("./cms-sub-contactus/cms-sub-contactus.component").then(
        (m) => m.CmsSubContactUsComponent,
      ),
  },
  {
    path: "app-cms-aboutuslanding",
    loadComponent: () =>
      import("./cms-aboutuslanding/cms-aboutuslanding.component").then(
        (m) => m.CmsAboutUsLandingComponent,
      ),
  },
  {
    path: "app-cms-aboutusservices",
    loadComponent: () =>
      import("./cms-aboutusservices/cms-aboutusservices.component").then(
        (m) => m.CmsAboutUsServicesComponent,
      ),
  },
  {
    path: "app-cms-aboutustimeline",
    loadComponent: () =>
      import("./cms-aboutustimeline/cms-aboutustimeline.component").then(
        (m) => m.CmsAboutUsTimelineComponent,
      ),
  },
  {
    path: "app-cms-logo",
    loadComponent: () =>
      import("./cms-logo/cms-logo.component").then((m) => m.CmsLogoComponent),
  },
  {
    path: "revenueManagement",
    component: RevenueManagementComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["revenueManagement"] },
  },
  {
    path: "agencySupplierRights",
    loadComponent: () =>
      import("./agencySupplierRights/agency-supplier-rights.component").then(
        (m) => m.AgencySupplierRightsComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["supplierManagement"] },
  },
  {
    path: "allocateBeneficiaryAccount",
    loadComponent: () =>
      import("./beneficiary-accounts-allocation/beneficiary-accounts-allocation.component").then(
        (m) => m.BeneficiaryAccountsAllocationComponent,
      ),
  },
  {
    path: "update-beneficiary-account",
    loadComponent: () =>
      import("./beneficiary-account/beneficiary-account.component").then(
        (m) => m.BeneficiaryAccountComponent,
      ),
  },
  {
    path: "beneficiary-account",
    loadComponent: () =>
      import("./create-beneficiary-account/create-beneficiary-account.component").then(
        (m) => m.CreateBeneficiaryAccountComponent,
      ),
  },
  {
    path: "agency_BranchGroups",
    loadComponent: () =>
      import("./agency_BranchGroups/agency_branch-groups.component").then(
        (m) => m.Agency_BranchGroupsComponent,
      ),
  },
  {
    path: "agency_BranchGroupList",
    loadComponent: () =>
      import("./agency_BranchGroupList/agency_branch-group-list.component").then(
        (m) => m.Agency_BranchGroupListComponent,
      ),
  },
  {
    path: "revenueManagementList",
    component: RevenueManagementListComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["revenueManagement"] },
  },
  { path: "offlineTicketIssue", component: OfflineTicketIssueComponent },
  { path: "pricingandstructure", component: PricingandstructureComponent },
  { path: "flightSearch", component: FlightSearchNew1Component },
  {
    path: "paymentAddEdit",
    loadComponent: () =>
      import("./paymentAddEdit/payment-add-edit.component").then(
        (m) => m.PaymentAddEditComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["addPayment", "approvePayment"] },
  },
  {
    path: "paymentList",
    loadComponent: () =>
      import("./paymentList/payment-list.component").then(
        (m) => m.PaymentListComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["addPayment"] },
  },
  {
    path: "managerPaymentList",
    loadComponent: () =>
      import("./managerPaymentList/manager-payment-list.component").then(
        (m) => m.ManagerPaymentListComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["approvePayment"] },
  },
  { path: "flightResults", component: FlightResultsNewComponent },
  { path: "offlineRequestList", component: OfflineRequestComponent },
  { path: "offlineRequestAddEdit", component: OfflineRequestAddEditComponent },
  {
    path: "managerOnlineRequestList",
    component: ManagerOnlineRequestListComponent,
  },
  {
    path: "managerOfflineRequestList",
    component: ManagerOfflineRequestListComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["managerOfflineRequestList"] },
  },
  { path: "passengerInfo", component: PassengerInfoComponent },
  {
    path: "managerList",
    loadComponent: () =>
      import("./managerList/manager-list.component").then(
        (m) => m.ManagerListComponent,
      ),
  },
  {
    path: "bookingList",
    component: BookingListComponent,
    canActivate: [PermissionGuard],
    data: {
      permissions: ["bookings", "viewBookings"],
      permissionCheckType: "any",
    },
  },
  { path: "ticket-issuance", component: TicketIssuanceComponent },
  {
    path: "airport",
    component: AirportManageComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["airport"] },
  },
  {
    path: "offline-my-booking-tkt-list",
    component: OfflineMyBookingTktListComponent,
  },
  { path: "refund-ticket-online", component: RefundTicketOnlineComponent },
  {
    path: "airline",
    component: AirlinesMasterComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["airline"] },
  },
  { path: "BookingSearch", component: BookingListSearchCriteriaComponent },
  {
    path: "B2BbackOffice",
    loadComponent: () =>
      import("./back-office-accounts/back-office-accounts.component").then(
        (m) => m.BackOfficeAccountsComponent,
      ),
  },
  {
    path: "about-us",
    loadComponent: () =>
      import("./about-us-sub/about-us-sub.component").then(
        (m) => m.AboutUsSubComponent,
      ),
  },
  {
    path: "contact-us",
    loadComponent: () =>
      import("./contact-us-sub/contact-us-sub.component").then(
        (m) => m.ContactUsSubComponent,
      ),
  },
  {
    path: "importPNR",
    component: ImportPnrComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["importPnr"] },
  },
  { path: "importPNRList", component: ImportPnrListComponent },
  { path: "voidRevenue", component: VoidRevenueManagementComponent },
  { path: "refundRevenue", component: RefundRevenueComponent },
  { path: "importRevenue", component: ImportRevenueManagementComponent },
  {
    path: "privacyPolicy",
    loadComponent: () =>
      import("./privacy-policy/privacy-policy.component").then(
        (m) => m.PrivacyPolicyComponent,
      ),
  },
  {
    path: "termsofuse",
    loadComponent: () =>
      import("./termsofuse/termsofuse.component").then(
        (m) => m.TermsofuseComponent,
      ),
  },
  {
    path: "beneficaryDetails",
    loadComponent: () =>
      import("./beneficary-details-list/beneficary-details-list.component").then(
        (m) => m.BeneficaryDetailsListComponent,
      ),
  },
  {
    path: "refundpolicy",
    loadComponent: () =>
      import("./refundpolicy/refundpolicy.component").then(
        (m) => m.RefundpolicyComponent,
      ),
  },
  {
    path: "addManagers",
    loadComponent: () =>
      import("./managers/managers.component").then((m) => m.ManagersComponent),
  },
  { path: "postAncillary", component: PostAncillaryComponent },
  {
    path: "groupTicket",
    component: GroupTicketComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["groupTicketRight"] },
  },
  { path: "flyDubaiModify", component: FlyDubaiModifyComponent },
  { path: "flyDubaiModify", component: AirblueModifyComponent },
  { path: "spiceModify", component: SpiceModificationComponent },
  { path: "flightResultModify", component: ModifyAirItineraryComponent },
  {
    path: "StatementofAccount",
    loadComponent: () =>
      import("./statement-of-account/statement-of-account.component").then(
        (m) => m.StatementOfAccountComponent,
      ),
    canActivate: [PermissionGuard],
    data: { reports: ["Statement of Account"] },
  },
  {
    path: "RateOfExchange",
    loadComponent: () =>
      import("./rate-of-exchange/rate-of-exchange.component").then(
        (m) => m.RateOfExchangeComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["currency"] },
  },
  {
    path: "RateOfExchangeList",
    loadComponent: () =>
      import("./rate-of-exchange-list/rate-of-exchange-list.component").then(
        (m) => m.RateOfExchangeListComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["currency"] },
  },
  {
    path: "paymentAddEdit/:response/:id",
    loadComponent: () =>
      import("./paymentAddEdit/payment-add-edit.component").then(
        (m) => m.PaymentAddEditComponent,
      ),
    canActivate: [PermissionGuard],
    data: {
      permissions: ["approvePayment", "bookings", "viewBookings"],
      permissionCheckType: "any",
    },
  },
  {
    path: "offlineBookingRequestCreate",
    component: OfflineBookingCreateComponent,
  },
  { path: "emiratesModify", component: EmiratesModificationComponent },
  { path: "importPnrEntry", component: ImportPnrEntryComponent },
  {
    path: "GroupRevenueReport",
    component: GroupRevenueReportComponent,
    canActivate: [PermissionGuard],
    data: { reports: ["Revenue Report", "Group Revenue Report"] },
  },
  {
    path: "revenueReport",
    component: RevenueReportComponent,
    canActivate: [PermissionGuard],
    data: { reports: ["Revenue Report", "Group Revenue Report"] },
  },
  {
    path: "addSuppliers",
    loadComponent: () =>
      import("./add-suppliers/add-suppliers.component").then(
        (m) => m.AddSuppliersComponent,
      ),
    canActivate: [PermissionGuard],
    data: { permissions: ["supplierManagement"] },
  },
  {
    path: "groupTicketForUserNew",
    component: GroupTicketForUserNewComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["groupTicketCreateRight"] },
  },
  { path: "addGroupTitle", component: AddGroupTitleComponent },
  {
    path: "zeus-insurance-home",
    component: TravelInsuranceComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["insuranceRight"] },
  },
  {
    path: "united-insurance-home",
    component: UnitedInsuranceHomeComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["insuranceRight"] },
  },
  {
    path: "insurance-issuance",
    component: TravelInsuranceIssuanceComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["insuranceIssuanceRight"] },
  },
  { path: "plans", component: TravelInsurancePlanResultsComponent },
  { path: "insured-passengers", component: TravelInsurancePassengersComponent },
  {
    path: "search-booked-plan/:id",
    component: TravelInsuranceBookingComponent,
  },
  {
    path: "cancel-insurance-policy",
    component: TravelInsuranceCancellationComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["insuranceCancelRight"] },
  },
  {
    path: "travel-insurance-revenue-management",
    component: TravelInsuranceRevenueManagementComponent,
  },
  { path: "united-travel-insurance", component: UnitedInsuranceComponent },
  {
    path: "register",
    loadComponent: () =>
      import("./register/register.component").then((m) => m.RegisterComponent),
  },
  {
    path: "registerList",
    loadComponent: () =>
      import("./register/register-list/register-list.component").then(
        (m) => m.RegisterListComponent,
      ),
  },
  {
    path: "managerProficiencyReport",
    component: ManagerProficiencyReportComponent,
  },
  { path: "travelPortModify", component: TravelPortModificationComponent },
  { path: "MasterSupplierPassenger", component: MasterPassengerInfoComponent },
  {
    path: "MasterSupplierPassengerlist",
    component: MasterPassengerInfoListComponent,
  },
  { path: "offlineSupplierList", component: OfflineSupplierListComponent },
  { path: "offlineSupplier", component: OfflineSupplierComponent },
  { path: "chatapp", component: ChatComponent },
  { path: "offlinebackoffice", component: OfflineBackOfficeReportComponent },
  {
    path: "offlineTicket",
    component: OfflineTicketComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["offlineTicket"] },
  },
  {
    path: "offlineBooking",
    component: OfflineBookingComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["offlineBooking"] },
  },
  {
    path: "offlineReissue",
    component: OfflineReissueComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["offlineResissue"] },
  },
  {
    path: "offlineRefund",
    component: OfflineRefundComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["offlineRefund"] },
  },
  {
    path: "offlineVoid",
    component: OfflineVoidComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["offlineVoid"] },
  },
  { path: "offlineFlightSearch", component: OfflineFlightSearchComponent },
  {
    path: "zeusBookedPolicy",
    component: ZeusBookedPoliciesComponent,
    canActivate: [PermissionGuard],
    data: { permissions: ["insuranceBookedViewRight"] },
  },
  {
    path: "companyMaster",
    loadComponent: () =>
      import("./companyMaster/companyMaster.component").then(
        (m) => m.CompanyMasterComponent,
      ),
  },
  {
    path: "insurance-report",
    component: BackOfficeInsuranceReportComponent,
    canActivate: [PermissionGuard],
    data: { reports: ["Insurance Report"] },
  },
  {
    path: "umra-offers",
    loadComponent: () =>
      import("./umra-offers/umra-offers.component").then(
        (m) => m.UmraOffersComponent,
      ),
  },
  {
    path: "shortlisted-package/:id",
    loadComponent: () =>
      import("./umra-shortlisted-package/umra-shortlisted-package.component").then(
        (m) => m.UmraShortlistedPackageComponent,
      ),
  },
  {
    path: "package-management",
    loadComponent: () =>
      import("./umra-package-management/umra-package-management.component").then(
        (m) => m.UmraPackageManagementComponent,
      ),
  },
  {
    path: "umra-reservation-requests",
    loadComponent: () =>
      import("./umra-manager-approval-list/umra-manager-approval-list.component").then(
        (m) => m.UmraManagerApprovalListComponent,
      ),
    //canActivate: [PermissionGuard], data: { permissions: ['umraManagerApprovalList'] }
  },
  {
    path: "travelport-pcc-for-import-pnr",
    loadComponent: () =>
      import("./travelport-pcc/travelport-pcc.component").then(
        (m) => m.TravelportPccComponent,
      ),
    //canActivate: [PermissionGuard], data: { permissions: ['umraManagerApprovalList'] }
  },
  {
    path: "my-umra-reservation-requests",
    loadComponent: () =>
      import("./umra-reservation-user-requests-list/umra-reservation-user-requests-list.component").then(
        (m) => m.UmraReservationUserRequestsListComponent,
      ),
    //canActivate: [PermissionGuard], data: { permissions: ['umraReservationUserRequestsList'] }
  },
  {
    path: "unauthorized",
    loadComponent: () =>
      import("./unauthorized/unauthorized.component").then(
        (m) => m.UnauthorizedComponent,
      ),
  },
  {
    path: "add-new-umra-offer",
    loadComponent: () =>
      import("./umra-custom-packages-add/umra-custom-packages-add.component").then(
        (m) => m.UmraCustomPackagesAddComponent,
      ),
  },
  {
    path: "hotel-management",
    loadComponent: () =>
      import("./hotel-management/hotel-management.component").then(
        (m) => m.HotelManagementComponent,
      ),
  },
  {
    path: "fetch-data-from-offline-id",
    component: ImportPnrForOfflineIssuedComponent,
  },
  {
    path: "create-invoice-from-pnr",
    component: DataFetchedFromOfflineComponent,
  },
  {
    path: "umra-supplier-management",
    loadComponent: () =>
      import("./umra-supplier-management/umra-supplier-management.component").then(
        (m) => m.UmraSupplierManagementComponent,
      ),
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
